<div class="bg-img" [class]="layOutData['LAYOUT_MODE'] == 'dark' ? 'bg-img-dark' : 'bg-img-light'"></div>

<div class="bg-invoice">
<!--  <img src="assets/images/bg-invoice.webp" width="100%">-->
</div>

@if (this.layOutData.LAYOUT === layOutTypes.VERTICAL) {
    <app-vertical></app-vertical>
}
@if (this.layOutData.LAYOUT === layOutTypes.HORIZONTAL) {
    <app-horizontal></app-horizontal>
}
